import type {
  PlanImageCardBorderStyle,
  PlanImageCardTextStyle,
} from 'src/domain/planImageCards/types'
import type { PlanTapelineConfig } from 'src/domain/planTables/types'
import { deleteRequest, patchRequest, postRequest } from '../utils'

export interface PlanImageCardCreateDTO {
  id?: string
  name: string
  position: { x: number; y: number; z: number }
  fileGuid: string
  titleLines: string[]
  width: number
  textStyle: PlanImageCardTextStyle
  borderStyle: PlanImageCardBorderStyle
  planConfig: PlanTapelineConfig
}

export interface PlanImageCardModifyDTO extends PlanImageCardCreateDTO {
  id?: never
}

export interface PlanImageCardDTO extends PlanImageCardCreateDTO {
  id: string
  dateCreated: string
  dateModified: string
}

export const createPlanImageCards: RequestTypeVariable = {
  getKey: (projectGuid: string) => ['createPlanImageCards', projectGuid],
  request: async (
    projectGuid: string,
    planImageCards: PlanImageCardCreateDTO[],
  ): Promise<PlanImageCardDTO[]> => {
    const { data: result } = await postRequest<PlanImageCardDTO[]>({
      url: `/projects/${projectGuid}/plan-image-cards`,
      data: planImageCards,
    })
    return result || []
  },
}

export const updatePlanImageCard: RequestTypeVariable = {
  getKey: (projectGuid: string, planImageCardId: string) => [
    'updatePlanImageCard',
    projectGuid,
    planImageCardId,
  ],
  request: async (
    projectGuid: string,
    planImageCardId: string,
    data: PlanImageCardModifyDTO,
  ): Promise<PlanImageCardDTO[]> => {
    const { data: result } = await patchRequest<PlanImageCardDTO[]>({
      url: `/projects/${projectGuid}/plan-image-cards/${planImageCardId}`,
      data,
    })
    return result || []
  },
}

export const deletePlanImageCards: RequestTypeVariable = {
  getKey: (projectGuid: string) => ['deletePlanImageCards', projectGuid],
  request: async (projectGuid: string, planImageCardIds: string[]): Promise<PlanImageCardDTO[]> => {
    const { data: result } = await deleteRequest<PlanImageCardDTO[]>({
      url: `/projects/${projectGuid}/plan-image-cards`,
      data: planImageCardIds,
    })
    return result || []
  },
}
